module.exports = __webpack_public_path__ + "static/media/stepper-manage-icon.0cee25ae.svg";